import BUApi from './_buApi';
import httpClient from '@/apis/base/httpclient';

class BUVoucherListAPI extends BUApi {
  constructor() {
    super();
  }
  controllerName = 'BUVoucherLists';
  /**
   * Lấy dữ liệu bảng kê
   * NXCHIEN 24.07.2022
   */
  getVoucherList(payload) {
    let request = {
      url: this.getAPIUrl() + '/VoucherList',
      data: payload,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu màn chọn chứng từ của bảng kê khác
   * @param {*} payload
   * @returns
   */
  GetSelectVoucherListOtherDetail(payload) {
    let request = {
      url: this.getAPIUrl() + '/GetSelectVoucherListOtherDetail',
      data: payload,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu filter header màn chọn chứng từ của bảng kê khác
   * @param {*} payload
   * @returns
   */
   GetFilterHeaderOtherDetail(payload) {
    let request = {
      url: this.getAPIUrl() + '/GetFilterHeaderOtherDetail',
      data: payload,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu màn chọn chứng từ của bảng kê khác
   * @param {*} payload
   * @returns
   */
  GetTotalRecordVoucherListOtherDetail(payload) {
    let request = {
      url: this.getAPIUrl() + '/GetTotalRecordVoucherListOtherDetail',
      data: payload,
    };
    return httpClient.postAsync(request);
  }
}

export default new BUVoucherListAPI();
